import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Sparkles, ArrowRight } from "lucide-react";
import { EXAMPLE_LIST } from "@/data/examples";

export default function IndustryExamples() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <main className="max-w-5xl mx-auto px-6 lg:px-8 py-16">
        <Badge variant="secondary" className="rounded-full bg-white border border-gray-200 text-slate-700" data-testid="examples-badge">
          <Sparkles className="h-3.5 w-3.5 mr-1.5" /> Bransje-eksempler
        </Badge>
        <h1 className="mt-6 text-4xl sm:text-5xl font-medium tracking-tight text-slate-900" data-testid="examples-title">
          Ferdige eksempelrapporter.
        </h1>
        <p className="mt-4 text-lg text-slate-600 max-w-2xl leading-relaxed">
          Se hvordan IdeSetGo bygger en fullstendig forretningsplan tilpasset ulike bransjer. Bruk dem som inspirasjon når du lager din egen.
        </p>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {EXAMPLE_LIST.map((ex) => (
            <Card
              key={ex.slug}
              className="bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300"
              data-testid={`example-card-${ex.slug}`}
            >
              <CardContent className="p-8 flex flex-col h-full">
                <div className={`inline-flex h-12 w-12 rounded-2xl items-center justify-center text-2xl border ${ex.color}`} aria-hidden>
                  {ex.icon}
                </div>
                <h3 className="mt-6 text-xl font-medium tracking-tight text-slate-900">{ex.label}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{ex.tagline}</p>
                <Link
                  to={`/eksempel/${ex.slug}`}
                  className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-slate-900 hover:underline"
                  data-testid={`example-link-${ex.slug}`}
                >
                  Se rapporten <ArrowRight className="h-3.5 w-3.5" />
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
